import React from 'react';
import { Plus } from 'lucide-react';
import { NewItem } from '../types';

interface AddItemProps {
    newItem: NewItem;
    onNewItemChange: (updates: Partial<NewItem>) => void;
    onAddItem: () => void;
}

const AddItem: React.FC<AddItemProps> = ({ newItem, onNewItemChange, onAddItem }) => {
    return (
        <div className="bg-white rounded-xl shadow-sm border p-6">
            <div className="flex items-center gap-3 mb-4">
                <Plus size={20} className="text-green-600"/>
                <h2 className="font-medium text-gray-800">افزودن آیتم جدید</h2>
            </div>

            <div className="grid md:grid-cols-4 gap-3">
                <input
                    type="text"
                    placeholder="عنوان آیتم"
                    value={newItem.title}
                    onChange={(e) => onNewItemChange({ title: e.target.value })}
                    className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                />
                <input
                    type="url"
                    dir={'ltr'}
                    placeholder="آدرس تصویر"
                    value={newItem.image}
                    onChange={(e) => onNewItemChange({ image: e.target.value })}
                    className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                />
                <input
                    type="url"
                    dir={'ltr'}
                    placeholder="آدرس لینک"
                    value={newItem.url}
                    onChange={(e) => onNewItemChange({ url: e.target.value })}
                    className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                />
                <button
                    onClick={onAddItem}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-lg flex items-center justify-center gap-2 transition-colors text-sm font-medium"
                >
                    <Plus size={16}/>
                    افزودن
                </button>
            </div>
        </div>
    );
};

export default AddItem; 